import clsx from "clsx";
import type { ChildrenProps } from "../types";

export function ContentCardScrollContainer({ children }: ChildrenProps) {
	return (
		<div className={clsx("h-full min-h-0 overflow-y-auto overflow-x-hidden", "-mx-4 px-4")}>
			{children}
		</div>
	);
}
